import React from "react";
import Environment from "~/common/Environment";
import { ContentUseOnly } from "./InternalNotesResult";
interface Props {
  contentUseOnlyData: ContentUseOnly;
  itemNumber: string;
}
const InternalNotesContentUseOnly = ({
  contentUseOnlyData,
  itemNumber
}: Props) => {
  const imageComments = contentUseOnlyData?.imageComments ?? null;
  const productHistoryRecords = contentUseOnlyData?.productHistoryRecords ?? null;
  const cachedDate = contentUseOnlyData?.cachedDate ?? null;
  const queuedDate = contentUseOnlyData?.queuedDate ?? null;
  const webComment = contentUseOnlyData?.itemWebComments?.webComment != null && contentUseOnlyData.itemWebComments.webComment.length > 0 ? contentUseOnlyData.itemWebComments.webComment : contentUseOnlyData.nwaWebComments;
  const encodedItemNumber = encodeURIComponent(itemNumber);
  return <div data-testid="contentUseOnly" data-sentry-component="InternalNotesContentUseOnly" data-sentry-source-file="InternalNotesContentUseOnly.tsx">
      <h4>
        <mark>Content Use Only</mark>
      </h4>
      <p data-testid="contentUseOnlyExpandedDescription">
        <strong>
          <a href={`https://adminportal.${Environment.domainWithEnvironment}/External/Item%20Expanded%20Description/IXD-Edit?itemNumber=${encodedItemNumber}`} target="_blank" rel="noopener noreferrer">
            Expanded Description
          </a>
        </strong>
      </p>
      {productHistoryRecords && <div data-testid="contentUseOnlyLastEdited">
          <p>
            <strong>
              User Last Edited:{" "}
              <a href={`https://adminportal.${Environment.domainWithEnvironment}/External/Item%20Detail%20Page/ItemDetailPage?itemNumber=${encodedItemNumber}`} target="_parent">
                {productHistoryRecords.userName}
              </a>
            </strong>
          </p>

          <p>
            <strong>
              Last Updated:{" "}
              <a href={`https://adminportal.${Environment.domainWithEnvironment}/External/Item%20Detail%20Page/ItemDetailPage?itemNumber=${encodedItemNumber}`} target="_parent">
                {productHistoryRecords.dateChangedDisplay.replace("@", "at")}
              </a>
            </strong>
          </p>
        </div>}
      <p>
        <strong>Last Queued:</strong>&nbsp;
        {queuedDate ? queuedDate.replace("@", "at") : ""}
      </p>
      <p>
        <strong>Last Cached:</strong>&nbsp;
        {cachedDate ? cachedDate.replace("@", "at") : ""}
      </p>
      <div className="message-feed" data-testid="contentUseOnlyComments">
        <>
          <p>
            <strong>Web-content Comments:</strong>
          </p>
          <div className="message-feed-item">{webComment}</div>
        </>
        <p>
          <strong>Image Comments:</strong>
        </p>
        {imageComments?.latestImageUploadUsername.length ? <>
            <div className="message-feed-item">
              {imageComments.latestImageComment}
            </div>
            <p>
              <strong>
                Last uploaded by {imageComments.latestImageUploadUsername}
              </strong>
            </p>
            <p>
              <strong>
                {imageComments.latestImageUploadDateChangedTimestamp.replace("@", "at")}
              </strong>
            </p>
          </> : <p>No image upload history.</p>}
      </div>
    </div>;
};
export default InternalNotesContentUseOnly;